import clsx from "clsx";
import React from "react";

import { useStoreLocator } from "../../../../hooks/use-store-locator";
import { StoreListItem, StoreListItemProps } from "./store-list-item";

export interface StoresListBodyProps {
  labels: {
    "store-locator-search-empty-state": string;
  } & StoreListItemProps["labels"];
  className?: string;
}

export function StoresListBody({ labels, className }: StoresListBodyProps) {
  const { setSelectedStoreId, selectedStoreId, filteredStores } = useStoreLocator();
  return (
    <div
      className={clsx(
        "flex flex-col gap-3 px-3 pb-3 pt-1 mr-1 overflow-auto",
        "neutral-scrollbar w-full h-full max-lg:min-h-[50vh]",
        className
      )}
    >
      {filteredStores.map((store, i) => (
        <StoreListItem
          store={store}
          labels={labels}
          key={i}
          isActive={selectedStoreId === store.id}
          onClick={() => setSelectedStoreId(store.id)}
        />
      ))}
      {!filteredStores.length && (
        <p className="font-light text-center pt-2">{labels["store-locator-search-empty-state"]}</p>
      )}
    </div>
  );
}
